<template>
  <div>
    <!-- Campaign Contents -->
    <div class="row justify-content-center">
      <!-- Content Card -->
      <div class="card shadow customs-card mx-2">
        <!-- Win Campaign Label -->
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">
            アタリ済みキャンペーン
          </p>
        </div>

        <div class="card-header border-0 px-4 mt-5 d-flex align-items-center">
          <div class="row">
            <!-- Prize Image -->
            <div class="col-5 col-sm-3 pr-1 align-self-center">
              <img
                :src="prize.imageUrl"
                alt="Prize"
                class="img-fluid mx-auto d-block"
              />
            </div>

            <!-- Prize Label -->
            <div class="col-7 col-sm-9 pl-1 align-self-center">
              <p
                class="text-justify mb-0 font-weight-bold text-bold text-color"
              >
                {{ prize.name }}
              </p>
            </div>
          </div>
        </div>

        <div
          v-if="prize.externalUrl.length > 0"
          @click="toExternalLink"
          class="btn card-footer border-0 background-card"
          style="
            border-bottom-left-radius: 1rem;
            border-bottom-right-radius: 1rem;
          "
        >
          <p class="text-center my-1 font-weight-bold text-bold text-white">
            賞品を受取る <i class="ml-2 ti-angle-right"></i>
          </p>
        </div>
      </div>
    </div>

    <!-- Cautions Label and Cautions Details -->
    <cautions :cautions="cautions"></cautions>
  </div>
</template>

<script>
import { getPrize, getCampaignCautions } from "@/utils/campaign";
import { setErrorMessage } from "@/utils/error";

import Cautions from "@/components/Cautions.vue";

export default {
  components: {
    Cautions,
  },
  data() {
    return {
      prize: {
        id: 0,
        code: null,
        name: "",
        imageUrl: "",
        externalUrl: "",
      },
      cautions: "",
      title: "クリップボードにコピーしました。",
    };
  },
  beforeRouteEnter(to, from, next) {
    if (getPrize()) {
      // TODO: render image before render html
      next((vm) => {
        // set prize data
        vm.setPrizeData(getPrize());

        // set caution data
        vm.setCampaignCautions(getPrize());
      });
    } else {
      next("/not-found");
    }
  },
  methods: {
    setPrizeData(result) {
      if (result.prizecodes) {
        this.prize.id = result.prizecodes.id || "0";
        this.prize.code = result.prizecodes.code || "";
      }

      this.prize.name = result.prizes.name || "";
      this.prize.imageUrl = process.env.BASE_API + result.prizes.image_of_prize;
      this.prize.externalUrl = result.prizes.external_url || "";
    },
    setCampaignCautions(cautions) {
      this.cautions = cautions.caution;
    },
    async copyCode() {
      await navigator.clipboard.writeText(this.prize.code);
      document.getElementById("tooltip").disabled = true;
      setTimeout(this.stopTimeOut, 2000);
    },
    stopTimeOut() {
      document.getElementById("tooltip").disabled = false;
      let tippy = document.getElementById("tippy-1");
      if (tippy !== undefined) {
        tippy.remove();
        document.getElementById("tooltip").click();
      }
    },
    formatCode(code) {
      if (typeof code === "string") {
        return code.replaceAll("-", " ");
      }

      return 0;
    },
    formatId(id) {
      // display code id with leading zeros
      const idString = "0000000000000000" + id;
      return idString
        .substr(idString.length - 16)
        .match(/.{1,4}/g)
        .join(" ");
    },
    toExternalLink() {
      window.open(this.prize.externalUrl, "_blank");
    },
  },
};
</script>

<style scoped></style>
